var SparkDigital = SparkDigital || {};

SparkDigital = (function () {

    /***********************************************************
    // GLOBAL - FOR STORING REUSABLE VARIABLES (EG. DOM)
    ***********************************************************/
    var global = {

        ajax_endpoints: window["ajax_endpoints"],

        google_recaptcha: window["google_recaptcha_site_key"],

        wp_nonce: window["wp_nonce"],

        breakpoint: {}, // bootstrap viewport

        assets_dir: window["assets_dir"],

        debug_mode: $('body').hasClass('debug-mode'), // Debug on-off state

        // Define ones that are being called everywhere
        elements: {
            body: $("body"),
            iframes: $("body.single iframe"), // Be specific where the iframes might be added
            // iframePopUps: $('[inline-youtube], [inline-video], [inline-gmaps]'), // For all iframe popups
        },

        site_lang: $('html').attr('lang'), // get site language

        storage_names: {
            // user_contact: "user-contact"
        },

        original_document_title: document.title,



    },
        /***********************************************************
        // COMPONENTS THAT ARE USED ON MORE THAN ONE PAGE & CALLABLE
        ***********************************************************/
        components = {

            swiperjs:function(){

                // @link https://swiperjs.com/swiper-api
                // make sure dependency is present
                if (typeof Swiper !== 'function') {
                    console.error('SwiperJS is a required');
                    return;
                }

                // Custom SwiperJS components
                $(".swiper[swiperjs-settings]").each(function(){                    

                    // Get JSON object from attribute
                    const swiperjs_settings = jQuery.parseJSON( $(this).attr("swiperjs-settings") ); 

                    if(typeof swiperjs_settings =='object'){

                        swiperjs_settings.pagination = swiperjs_settings.pagination != undefined && swiperjs_settings.pagination == true ? {
                            el: '.swiper-pagination',
                            clickable: true
                          } : '';

                        swiperjs_settings.navigation = swiperjs_settings.navigation != undefined && swiperjs_settings.navigation == true ? {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                          } : '';

                        new Swiper($(this).get(0), swiperjs_settings);

                        if (global.debug_mode) {
                            console.log(swiperjs_settings);
                        }
                        
                    }


                });

            },

            // HandleBars
            handlebars: {

                // Use for tracking initialisation state
                init: false,

                // Use for storing cached template that has been compiled
                cached_template: {},

                // Render Template
                render: function (templateElement) {

                    // console.log("handlebars.render");

                    // Initialise helper if haven't 
                    if (this.init === false) this.extend();

                    if (templateElement === "" || templateElement === null) {
                        return false;
                    }

                    // Get ID and used for cached
                    var templateName = $(templateElement).attr("ID");

                    // console.log("Template Name: "+templateName);
                    // console.log(this.cached_template[templateName]);

                    if (this.cached_template[templateName] != undefined) {

                        // console.log("CACHED TEMPLATE");
                        return this.cached_template[templateName];

                    } else {

                        var templateSource = $(templateElement).html();

                        if (templateSource !== "" || templateSource !== null) {

                            // Compile handlebars and return
                            this.cached_template[templateName] = Handlebars.compile(templateSource);
                            return this.cached_template[templateName];
                        }
                    }

                    return false;
                },

                // Extend such as additional kelpers
                extend: function () {

                    // debug helper
                    // usage: {{debug}} or {{debug someValue}}
                    // from: @commondream (http://thinkvitamin.com/code/handlebars-js-part-3-tips-and-tricks/)
                    Handlebars.registerHelper("debug", function (optionalValue) {
                        console.log("Current Context");
                        console.log("====================");
                        console.log(this);

                        if (optionalValue) {
                            console.log("Value");
                            console.log("====================");
                            console.log(optionalValue);
                        }
                    });

                    Handlebars.registerHelper('reverse', function (arr) {

                        //console.log(typeof(arr))
                        if (global.polyfill_isArray(arr)) {
                            arr.reverse();
                        } else {
                            arr;
                        }

                    });

                    Handlebars.registerHelper('str_concatnate', function (a, b, opts) {
                        var str_combined = a + '' + b;
                        return new Handlebars.SafeString(str_combined);
                    });

                    Handlebars.registerHelper('str_replace', function (a, b, c, opts) {
                        var str_replaced = a.replace(b, c);
                        return new Handlebars.SafeString(str_replaced);
                    });

                    // Provides conditional string checks
                    Handlebars.registerHelper('if_eq', function (a, b, opts) {
                        if (a === b) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if string contains
                    Handlebars.registerHelper('if_contains', function (a, b, opts) {
                        if (a.indexOf(b) >= 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if obj contains
                    Handlebars.registerHelper('if_obj_contains', function (a, b, c, opts) {

                        var obj_founds = global.search_object_by_key(a, b, c);

                        if (obj_founds.length > 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if it's an object
                    Handlebars.registerHelper('is_obj', function (item, options) {
                        if (typeof item === "object") {
                            return options.fn(this);
                        } else {
                            return options.inverse(this);
                        }
                    });

                    // Comparsion Check
                    Handlebars.registerHelper('if_compare', function (lvalue, operator, rvalue, opts) {

                        var operators, result;

                        if (arguments.length < 3) {
                            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
                        }

                        if (opts === undefined) {
                            opts = rvalue;
                            rvalue = operator;
                            operator = "===";
                        }

                        operators = {
                            '==': function (l, r) {
                                return l == r;
                            },
                            '===': function (l, r) {
                                return l === r;
                            },
                            '!=': function (l, r) {
                                return l != r;
                            },
                            '!==': function (l, r) {
                                return l !== r;
                            },
                            '<': function (l, r) {
                                return l < r;
                            },
                            '>': function (l, r) {
                                return l > r;
                            },
                            '<=': function (l, r) {
                                return l <= r;
                            },
                            '>=': function (l, r) {
                                return l >= r;
                            },
                            'typeof': function (l, r) {
                                return typeof l == r;
                            }
                        };

                        if (!operators[operator]) {
                            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
                        }

                        result = operators[operator](lvalue, rvalue);

                        if (result) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }

                    });

                    //  Format a date
                    //  @link https://github.com/phstc/jquery-dateFormat
                    Handlebars.registerHelper('DateFormat', function (input, dateformat) {

                        // Normalize date to unix time
                        var unixTimestamp = new Date().getTime(input);
                        unixTimestamp = new Date(unixTimestamp).toISOString();

                        dateformat = dateformat == '' ? 'dd/MM/yyyy' : dateformat;

                        if (dateformat == 'pretty') {
                            return new Handlebars.SafeString($.format.prettyDate(new Date(unixTimestamp)));
                        } else {
                            return new Handlebars.SafeString($.format.date(new Date(unixTimestamp), dateformat));
                        }

                    });

                    // Finished initialisation
                    this.init = true;

                }


            },

            // Site Nav
            siteNav: function(){

                $('.hover').bind('touchstart touchend', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('hoverfx');
                });

                //Creates variables menu and menulink
                var $menu = $('.navli'),
                $menulink = $('#menubtn');

                //Changes instances of hover to mobile touch
                $('.hover').bind('touchstart touchend', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('hoverfx');
                });

                //Adds .parent to any anchor with an UL after it
                $(".navli li a").each(function () {
                    if ($(this).next().length > 0) {
                        $(this).addClass('parent');
                    }
                });

                //Adds .dropdn to any li with an UL after it
                $(".navli li").each(function () {
                    if ($(this).children('ul').length > 0) {
                        $(this).addClass('dropdn');
                    }
                });

                //Makes #menubtn clickable
                $menulink.click(function (e) {
                    e.preventDefault();
                    $menulink.toggleClass('collapsed');
                    $menulink.toggleClass('activ');
                    $menu.toggleClass('activ');
                    $('.nav-holder, header.fixed-top').toggleClass('active');
                });

                //Creates clickable .nav-more div
                $(function () {
                    $('<div class="nav-more">&nbsp;</div>').insertAfter('a.parent');
                });

                //Makes ul after an li clickable
                $(function () {
                    $('.nav-more').click(function (e) {
                        e.preventDefault();
                        $(this).toggleClass('activ');
                        $(this).next("ul").toggleClass('activ');
                        $(".navli li a").unbind('mouseenter mouseleave');
                        $(".navli li ul li").unbind('mouseenter mouseleave');
                    });
                });
            },

            // Taxonomy Filters Component (Reusable)
            // Used in resources listing, search results, archives, etc.
            taxonomiesListingFilters: function() {
                'use strict';
                
                // Check if we have any taxonomy filter components on the page
                var $filterComponents = $('.taxonomy-filters');

                // Track filter option changes, and remove "paged" param in URL on change
                var $filtersHash = generateHash(buildSfParameter(null));
                
                if ($filterComponents.length === 0) {
                    return;
                }

                $filterComponents.each(function() {
                    
                    var $component = $(this);


                    // Desktop: Track checkbox changes per taxonomy dropdown
                    $($component).on('change', '.filter-dropdown-menu .taxonomy-filter-checkbox', function() {
                        var $dropdown = $(this).closest('.filter-dropdown-menu');
                        var $filterDropdown = $(this).closest('.filter-dropdown');
                        var taxonomy = $(this).data('taxonomy');
                        updateFilterCount($filterDropdown, taxonomy, $component);
                        updateMobileFilterCount();
                    });
                    
                    // Mobile: Track checkbox changes in modal
                    $($component).on('change', '.filters-modal .taxonomy-filter-checkbox', function() {
                        updateMobileFilterCount();
                    });
                    
                    // Desktop: Apply button - build sf parameter and redirect
                    $($component).on('click', '.apply-filters-btn', function(e) {
                        e.preventDefault();
                        // var taxonomy = $(this).data('taxonomy');
                        // applyFilters(taxonomy);
                        applyAllFilters();
                    });
                    
                    // Desktop: Clear button - uncheck taxonomy's checkboxes
                    $($component).on('click', '.clear-taxonomy-filters-btn', function(e) {
                        e.preventDefault();
                        var taxonomy = $(this).data('taxonomy');
                        clearTaxonomyFilters(taxonomy, $component);
                    });
                    
                    // Mobile: Apply button in modal - build sf parameter and redirect
                    $($component).on('click', '.apply-filters-modal-btn', function(e) {
                        e.preventDefault();
                        applyAllFilters();
                    });
                    
                    // Mobile: Clear button in modal - uncheck all checkboxes
                    $($component).on('click', '.filters-modal .clear-all-filters-btn', function(e) {
                        e.preventDefault();
                        clearAllFilters($component);
                    });
                    
                    // Clear all filters link (top-level)
                    $($component).on('click', '.clear-all-filters-link', function(e) {
                        e.preventDefault();
                        window.location.href = window.location.pathname;
                    });
                    
                    // Prevent dropdown from closing when clicking checkboxes
                    $($component).on('click', '.filter-dropdown-menu', function(e) {
                        e.stopPropagation();
                    });
                    
                    // Sync checkboxes between desktop and mobile
                    $($component).on('change', '.taxonomy-filter-checkbox', function() {
                        var value = $(this).val();
                        var isChecked = $(this).is(':checked');
                        
                        // Sync with other checkboxes with same value
                        $('.taxonomy-filter-checkbox[value="' + value + '"]').prop('checked', isChecked);
                    });
                });



                // Generate hash from string
                function generateHash(string) {
                    let hash = 0;
                    for (const char of string) {
                        hash = (hash << 5) - hash + char.charCodeAt(0);
                        hash |= 0; // Constrain to 32bit integer
                    }
                    return hash;
                }
                
                // Helper: Update count badge on filter button
                function updateFilterCount($filterDropdown, $taxonomy, $mainElement) {
                    var $dropdown = $filterDropdown.find('.filter-dropdown-menu');
                    var count = $dropdown.find('.taxonomy-filter-checkbox:checked').length;
                    var $button = $filterDropdown.find('.filter-pill');
                    
                    // Hide for individual Clear button if no filters selected
                    if(count > 0){
                        $($filterDropdown).find('.clear-taxonomy-filters-btn').removeClass('hidden');
                    }else{
                        $($filterDropdown).find('.clear-taxonomy-filters-btn').addClass('hidden');
                    }
                        
                    // Hide main Clear All Filters link if no filters selected
                    // $checked_items = $($mainElement).find('.taxonomy-filter-checkbox[data-taxonomy]:checked');
                    // if($checked_items.length > 0){
                    //     $($clearAllFilterBtn).removeClass('hidden');
                    // }else{
                    //     $($clearAllFilterBtn).addClass('hidden');
                    // }

                    updateButtonBadge($button, count);
                }
                
                // Helper: Update button text with count
                function updateButtonBadge($button, count) {
                    var baseText = $button.data('base-text');
                    var $countBadge = $button.find('.count-badge');
                    
                    if (count > 0) {
                        if ($countBadge.length === 0) {
                            $button.append(' <span class="count-badge">' + count + '</span>');
                        } else {
                            $countBadge.text(count);
                        }
                        $button.addClass('active');
                    } else {
                        $countBadge.remove();
                        $button.removeClass('active');
                    }
                }
                
                // Helper: Build sf parameter from checked checkboxes
                function buildSfParameter(taxonomy) {
                    var sfValues = [];
                    var selector = taxonomy ? 
                        '.taxonomy-filter-checkbox[data-taxonomy="' + taxonomy + '"]:checked' : 
                        '.taxonomy-filter-checkbox:checked';
                    
                    $(selector).each(function() {
                        var value = $(this).val();
                        if (sfValues.indexOf(value) === -1) {
                            sfValues.push(value);
                        }
                    });
                    return sfValues.join(',');
                }
                
                // Helper: Apply filters for specific taxonomy
                function applyFilters(taxonomy) {
                    var currentUrl = new URL(window.location.href);
                    var currentSf = currentUrl.searchParams.get('sf') || '';
                    var currentSfArray = currentSf ? currentSf.split(',') : [];
                    
                    // Remove old values for this taxonomy
                    var taxonomyPrefix = 'ct-' + taxonomy.replace('ct-', '');
                    currentSfArray = currentSfArray.filter(function(val) {
                        return !val.startsWith(taxonomyPrefix);
                    });
                    
                    // Add new values for this taxonomy
                    var newValues = buildSfParameter(taxonomy);
                    if (newValues) {
                        var newValuesArray = newValues.split(',');
                        currentSfArray = currentSfArray.concat(newValuesArray);
                    }
                    
                    // Update URL and redirect
                    if (currentSfArray.length > 0) {
                        currentUrl.searchParams.set('sf', currentSfArray.join(','));
                    } else {
                        currentUrl.searchParams.delete('sf');
                    }
                    
                    currentUrl = currentUrl.toString();

                    if($filtersHash != generateHash( buildSfParameter(null) )){
                        
                        currentUrl = removePagedFromURL(currentUrl);

                        window.location.href = currentUrl;

                    }else{
                        window.location.href = currentUrl.toString();
                    }
                    
                }
                
                // Helper: Apply all filters (mobile modal)
                function applyAllFilters() {
                    var sfParam = buildSfParameter(null);
                    var currentUrl = new URL(window.location.href);
                    
                    if (sfParam) {
                        
                        currentUrl.searchParams.set('sf', sfParam);

                    } else {
                        
                        currentUrl.searchParams.delete('sf');

                    }

                    currentUrl = currentUrl.toString();

                    if($filtersHash != generateHash( buildSfParameter(null) )){
                        
                        currentUrl = removePagedFromURL(currentUrl);

                        window.location.href = currentUrl;

                    }else{
                        window.location.href = currentUrl.toString();
                    }

                }
                
                // Helper: Clear taxonomy filters
                function clearTaxonomyFilters(taxonomy, targetElement) {
                    $('.taxonomy-filter-checkbox[data-taxonomy="' + taxonomy + '"]').prop('checked', false);
                    var $dropdown = $('.filter-dropdown[data-taxonomy="' + taxonomy + '"]');
                    updateFilterCount($dropdown, taxonomy, targetElement);
                    updateMobileFilterCount();
                }
                
                // Helper: Clear all filters
                function clearAllFilters(target) {
                    $('.taxonomy-filter-checkbox').prop('checked', false);
                    
                    // Update all desktop filter buttons
                    $('.filter-pill').each(function() {
                        updateButtonBadge($(this), 0);
                    });

                    $(target).find('.clear-all-filters-link').addClass('hidden');

                    updateMobileFilterCount();
                }
                
                // Helper: Update mobile filter button count
                function updateMobileFilterCount() {
                    // Count unique filter values (not all checkboxes, since desktop and mobile have separate checkboxes)
                    var uniqueValues = new Set();
                    $('.taxonomy-filter-checkbox:checked').each(function() {
                        uniqueValues.add($(this).val());
                    });
                    var count = uniqueValues.size;
                    
                    var $button = $('.filter-button-mobile');
                    var baseText = $button.data('base-text') || 'Filters';
                    var $filterText = $button.find('.filter-text');
                    
                    if (count > 0) {
                        $button.addClass('active');
                        $filterText.html(baseText + ' <span class="count-badge">' + count + '</span>');
                    } else {
                        $button.removeClass('active');
                        $filterText.html(baseText);
                    }
                }

                // Remove /paged\/\d+\?/ matches "paged/" followed by any digits and a literal "?"
                function removePagedFromURL(url) {
                    
                    const cleanUrl = url.replace(/paged\/\d+/, "");
                    return cleanUrl;
                    
                }
                
                // Initialize: Set base text data attributes for desktop buttons
                $('.filter-pill').each(function() {
                    var $this = $(this);
                    var text = $this.data('base-text');
                    
                    // If base-text is not set, extract it from button text (remove any count badge)
                    if (!text) {
                        text = $this.text().trim().replace(/\s+\d+$/, '');
                        $this.data('base-text', text);
                    }
                });
                
                // Initialize mobile button
                var mobileBaseText = 'Filters';
                $('.filter-button-mobile').data('base-text', mobileBaseText);
                updateMobileFilterCount();
                
                if (global.debug_mode) {
                    console.log('Taxonomy Filters initialized for ' + $filterComponents.length + ' component(s)');
                }
            },

            // Copy Link to Clipboard
            copyLink: function() {
                'use strict';
                
                // Check if we have any copy link buttons on the page
                var $copyLinkButtons = $('.post-meta-btn--copy');
                
                if ($copyLinkButtons.length === 0) {
                    return;
                }
                
                // Handle copy link button clicks
                $(document).on('click', '.post-meta-btn--copy', function(e) {
                    e.preventDefault();
                    
                    var $button = $(this);
                    var urlToCopy = $button.data('url') || window.location.href;
                    var originalText = $button.text();
                    var successText = $button.data('success-text') || 'Copied!';
                    var errorMessage = $button.data('error-message') || 'Failed to copy link';
                    var resetDelay = parseInt($button.data('reset-delay')) || 2000;
                    
                    // Check if Clipboard API is supported
                    if (!navigator.clipboard) {
                        // Fallback for older browsers
                        copyLinkFallback(urlToCopy, $button, originalText, successText, errorMessage, resetDelay);
                        return;
                    }
                    
                    // Use modern Clipboard API
                    navigator.clipboard.writeText(urlToCopy)
                        .then(function() {
                            // Success - update button text
                            $button.text(successText);
                            $button.addClass('copied');
                            
                            // Reset button text after delay
                            setTimeout(function() {
                                $button.text(originalText);
                                $button.removeClass('copied');
                            }, resetDelay);
                            
                            if (global.debug_mode) {
                                console.log('Link copied to clipboard:', urlToCopy);
                            }
                        })
                        .catch(function(err) {
                            // Error handling
                            console.error('Failed to copy link:', err);
                            alert(errorMessage);
                        });
                });
                
                // Fallback method for older browsers (IE11, older Safari)
                function copyLinkFallback(text, $button, originalText, successText, errorMessage, resetDelay) {
                    // Create a temporary textarea element
                    var $temp = $('<textarea>');
                    $temp.val(text);
                    $temp.css({
                        position: 'absolute',
                        left: '-9999px',
                        top: '-9999px'
                    });
                    $('body').append($temp);
                    
                    // Select and copy the text
                    $temp.select();
                    $temp[0].setSelectionRange(0, 99999); // For mobile devices
                    
                    try {
                        var successful = document.execCommand('copy');
                        if (successful) {
                            // Success - update button text
                            $button.text(successText);
                            $button.addClass('copied');
                            
                            // Reset button text after delay
                            setTimeout(function() {
                                $button.text(originalText);
                                $button.removeClass('copied');
                            }, resetDelay);
                            
                            if (global.debug_mode) {
                                console.log('Link copied to clipboard (fallback):', text);
                            }
                        } else {
                            throw new Error('execCommand failed');
                        }
                    } catch (err) {
                        console.error('Fallback copy failed:', err);
                        alert(errorMessage);
                    }
                    
                    // Remove temporary element
                    $temp.remove();
                }
                
                if (global.debug_mode) {
                    console.log('Copy Link functionality initialized for ' + $copyLinkButtons.length + ' button(s)');
                }
            },

            // Web Share API
            webShare: function() {
                'use strict';
                
                // Check if we have any share buttons on the page
                var $shareButtons = $('.post-meta-btn--share');
                
                if ($shareButtons.length === 0) {
                    return;
                }
                
                // Check if Web Share API is supported
                if (navigator.share) {
                    // Add support class to show the button
                    $shareButtons.addClass('web-share-supported');
                    
                    // Handle share button clicks
                    $(document).on('click', '.post-meta-btn--share', function(e) {
                        e.preventDefault();
                        
                        var $button = $(this);
                        var shareTitle = $button.data('share-title') || document.title;
                        var shareUrl = $button.data('share-url') || window.location.href;
                        
                        navigator.share({
                            title: shareTitle,
                            url: shareUrl
                        })
                        .then(function() {
                            if (global.debug_mode) {
                                console.log('Content shared successfully');
                            }
                        })
                        .catch(function(err) {
                            // User cancelled or error occurred
                            if (global.debug_mode) {
                                console.log('Share cancelled or failed:', err);
                            }
                        });
                    });
                    
                    if (global.debug_mode) {
                        console.log('Web Share API supported and initialized for ' + $shareButtons.length + ' button(s)');
                    }
                } else {
                    // Web Share API not supported - buttons remain hidden via CSS
                    if (global.debug_mode) {
                        console.log('Web Share API not supported - share buttons hidden');
                    }
                }
            },

            // In-line floating page menu
            pageSectionsMenu: {

                data: { 'items': [] }, // User for outut
                template: "script#x-template-page-sections-menu", // Handlebars JQuery selector
                handelbars: null, // For storing compiled Handlebars

                init: function () {
                    let _self = this;

                    if ($(_self.template).length === 0) {
                        return null;
                    }

                    const bodyClasses = ($('body').attr('class') || '').split(/\s+/);
                    const isDevelopmentPage = bodyClasses.some(cls => cls.startsWith('page-development'));

                    if (isDevelopmentPage) {
                        // Special logic for development pages
                        const elements = $('main section .content-block-heading > h3');
                        elements.each(function () {
                            const section = $(this).closest('section[id]');
                            if (section.length > 0) {
                                const section_id = section.attr('id');
                                const section_heading = $(this).text();
                                if (section_id && section_heading) {
                                    _self.data.items.push({
                                        'title': section_heading,
                                        'url': '#' + section_id
                                    });
                                }
                            }
                        });
                    } else {
                        // Standard logic for all other pages
                        let sectionCounter = 0;
                        $('main section[id]:not([class*="visually-hidden"])').each(function () {
                            sectionCounter++;
                            const section = $(this);
                            let heading = section.find('.content-block-heading :header').first();
                            let section_heading;

                            // Use heading tag if exists or generalised heading
                            // if (heading.length > 0) {
                            //     section_heading = heading.text();
                            // } else {
                            //     section_heading = 'Section #' + sectionCounter;
                            // }

                            section_heading = 'Section #' + sectionCounter;
                            
                            const section_id = section.attr('id');

                            if (section_id && section_heading) {
                                _self.data.items.push({
                                    'title': section_heading,
                                    'url': '#' + section_id
                                });
                            }
                        });
                    }

                    if (_self.data.items.length > 0) {
                        _self.render_data(_self.data);
                    }
                },

                // Will render data using HandleBars
                render_data: function (data) {

                    const _self = this;

                    // Load Handlebars template
                    let HTMLTemplate = components.handlebars.render($(_self.template));

                    // Compile data into HTML using Handlebars
                    let outputHTML = HTMLTemplate(data);

                    // Add all the items
                    if ($('main section.header-block-simple').length > 0) {
                        $(outputHTML).insertAfter($('main section.header-block-simple'));
                    } else {
                        $(outputHTML).insertAfter($('main section').first());
                    }

                    // Add click event for smooth scroll to top
                    $('.page-sections-menu [href="#top"]').on('click', function(e) {
                        e.preventDefault();
                        if ($(this).length) {
                            $('html, body').animate({
                                scrollTop: 0
                            }, 500);
                        }
                    });
                
                    // Add click event for smooth scroll and flash effect
                    const navLinks = $('.page-sections-menu a.dropdown-item[href^="#"]');
                    navLinks.on('click', function(e) {
                        e.preventDefault();
                        const targetId = $(this).attr('href');
                        
                        // Ensure the targetId is a valid selector
                        if (targetId.length > 1) {
                            const targetElement = $(targetId);

                            if (targetElement.length) {
                            $('html, body').animate({
                                scrollTop: targetElement.offset().top
                            }, 500, function() {
                                // Short delay to ensure the element is in view
                                setTimeout(function() {
                                    // Create and animate the flash overlay
                                    const overlay = $('<div>').css({
                                        position: 'absolute',
                                        top: targetElement.offset().top,
                                        left: targetElement.offset().left,
                                        width: targetElement.outerWidth(),
                                        height: targetElement.outerHeight(),
                                        backgroundColor: 'white',
                                        opacity: 0,
                                        zIndex: 9999,
                                        pointerEvents: 'none' // Ensure overlay doesn't interfere with user interaction
                                    }).appendTo('body');

                                    // Chain animations for a triple flash effect
                                    overlay.animate({ opacity: 0.7 }, 150)
                                           .animate({ opacity: 0 }, 150)
                                           .animate({ opacity: 0.7 }, 150)
                                           .animate({ opacity: 0 }, 150)
                                           .animate({ opacity: 0.7 }, 150)
                                           .animate({ opacity: 0 }, 150, function() {
                                               $(this).remove();
                                           });
                                }, 100); // 100ms delay
                            });
                            }
                        }
                    });
                }

            },

            // GEO
            geo: {

                /**
                 * Get User geolocation 
                 */
                get_user_geolocation: function () {

                    // Try HTML5 geolocation.
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                const pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };

                                return pos;
                            }
                        );
                    }

                    return false;

                },
            },

            // Google Tag Manager
            gtm: {

                /**
                 *  Google Tag Manager
                 */
                dataLayerGAEventTracking: function (category, action, label, value) {

                    window.dataLayer = window.dataLayer || [];

                    // Ensure GTM is load in initiated
                    if (typeof window.dataLayer !== 'undefined') {

                        window.dataLayer.push({
                            'event': 'ga_event',
                            'eventCategory': category,
                            'eventAction': action,
                            'eventLabel': label,
                            'eventValue': value
                        });

                    }


                },

            },

            // Expand/Collapse Component (Generic & Reusable)
            // Used for showing/hiding items in listings (team members, resources, etc.)
            expandCollapse: function() {
                'use strict';
                
                // Find all expand/collapse containers on the page
                var $containers = $('.expand-collapse-container');
                
                if ($containers.length === 0) {
                    return;
                }
                
                $containers.each(function() {
                    var $container = $(this);
                    var $button = $container.find('.expand-collapse-btn');
                    var $items = $container.find('.expand-collapse-item');
                    
                    if ($button.length === 0 || $items.length === 0) {
                        return;
                    }
                    
                    // Get configuration from data attributes
                    var initialCount = parseInt($button.data('initial-count')) || 8;
                    var expandedText = $button.data('expanded-text') || 'Show Less';
                    var collapsedText = $button.data('collapsed-text');
                    
                    // Store original button text if not already stored
                    if (!$button.data('original-text')) {
                        var originalText = $button.text().trim();
                        $button.data('original-text', originalText);
                        
                        // Use original text as collapsed text if not specified via data attribute
                        if (!collapsedText) {
                            collapsedText = originalText;
                        }
                    } else {
                        // Use stored original text if collapsed text not specified
                        if (!collapsedText) {
                            collapsedText = $button.data('original-text');
                        }
                    }
                    
                    // Store reference to all items beyond initial count
                    var $hiddenItems = $items.slice(initialCount);
                    
                    // Only show button if there are more items than initial count
                    if ($items.length <= initialCount) {
                        $button.hide();
                        return;
                    }
                    
                    // Hide items beyond initial count immediately
                    $hiddenItems.addClass('hidden');
                    
                    // Set initial button state
                    $button.data('expanded', false);
                    $button.text(collapsedText);
                    
                    // Handle button click
                    $button.on('click', function(e) {
                        e.preventDefault();
                        
                        var $btn = $(this);
                        var isCurrentlyExpanded = $btn.data('expanded') === true;
                        
                        if (isCurrentlyExpanded) {
                            // Currently expanded, so collapse it
                            $hiddenItems.addClass('hidden');
                            $btn.data('expanded', false);
                            $btn.text(collapsedText);
                        } else {
                            // Currently collapsed, so expand it
                            $hiddenItems.removeClass('hidden');
                            $btn.data('expanded', true);
                            $btn.text(expandedText);
                        }
                        
                        // Toggle expanded class for arrow rotation
                        $btn.toggleClass('expanded', !isCurrentlyExpanded);
                    });
                });
            },

            // Posts & Events Listing Filters (Toggle Behavior)
            postsEventsFilters: function() {
                'use strict';
                
                // Check if we have the posts-events-filters component on the page
                var $filterComponent = $('.posts-events-filters');
                
                if ($filterComponent.length === 0) {
                    return;
                }
                
                // Handle filter button clicks
                $filterComponent.find('.filter-btn').on('click', function(e) {
                    var $clickedBtn = $(this);
                    var isCurrentlyActive = $clickedBtn.hasClass('active');
                    
                    // Update button states immediately (before page navigation)
                    if (isCurrentlyActive) {
                        // If clicking an active button, remove active state (will navigate to base URL)
                        $clickedBtn.removeClass('active');
                    } else {
                        // If clicking an inactive button, remove active from all and add to clicked
                        $filterComponent.find('.filter-btn').removeClass('active');
                        $clickedBtn.addClass('active');
                    }
                    
                    // Allow the link navigation to proceed naturally
                    // The href already handles the correct URL based on active state
                });
            },

            // Guided Access Carousel (Form-based with button state management)
            guidedAccessCarousel: function() {
                'use strict';
                
                var $carousels = $('.guided-access-carousel');
                
                if ($carousels.length === 0) {
                    return;
                }
                
                $carousels.each(function() {
                    var $carousel = $(this);
                    var $form = $carousel.closest('form');
                    
                    // Function to check if current slide has a selection
                    function updateButtonState($slide) {
                        var hasSelection = $slide.find('.guided-access-radio:checked').length > 0;
                        // Only target Continue button (carousel-control-next) and Submit button, NOT the Back button
                        var $button = $slide.find('.carousel-control-next, .guided-access-submit-btn');
                        
                        if ($button.length) {
                            if (hasSelection) {
                                $button.prop('disabled', false);
                                $button.removeAttr('disabled');
                            } else {
                                $button.prop('disabled', true);
                                $button.attr('disabled', 'disabled');
                            }
                        }
                    }
                    
                    // Radio button change event
                    $carousel.on('change', '.guided-access-radio', function() {
                        var $currentSlide = $(this).closest('.carousel-item');
                        updateButtonState($currentSlide);
                    });
                    
                    // Handle deselection (from misc_func radio deselect behavior)
                    $carousel.on('click', '.guided-access-radio', function() {
                        var $currentSlide = $(this).closest('.carousel-item');
                        // Small delay to allow deselection to complete
                        setTimeout(function() {
                            updateButtonState($currentSlide);
                        }, 50);
                    });
                    
                    // When carousel slides, update button state for new slide
                    $carousel.on('slid.bs.carousel', function(e) {
                        var $activeSlide = $(e.relatedTarget);
                        updateButtonState($activeSlide);
                    });
                    
                    // Intercept form submission to build sf parameter in existing format
                    if ($form.length) {
                        $form.on('submit', function(e) {
                            e.preventDefault();
                            
                            var formAction = $(this).attr('action');
                            var sfValues = [];
                            
                            // Collect hidden input for role
                            $(this).find('input[type="hidden"]').each(function() {
                                var name = $(this).attr('name');
                                var value = $(this).val();
                                
                                if (name && value) {
                                    // Build taxonomy--value pairs
                                    sfValues.push(name + '--' + value);
                                }
                            });
                            
                            // Collect checked radios using data-taxonomy attribute
                            // This allows multiple steps to have the same taxonomy_type
                            $(this).find('input[type="radio"]:checked').each(function() {
                                var taxonomy = $(this).data('taxonomy');
                                var value = $(this).val();
                                
                                if (taxonomy && value) {
                                    // Build taxonomy--value pairs (allows duplicates for same taxonomy)
                                    sfValues.push(taxonomy + '--' + value);
                                }
                            });
                            
                            // Build final URL with sf parameter in existing format
                            if (sfValues.length > 0 && formAction) {
                                var queryString = '?sf=' + sfValues.join('%2C');
                                var finalUrl = formAction + queryString;
                                
                                // Redirect to final URL
                                window.location.href = finalUrl;
                            }
                            
                            return false;
                        });
                    }
                    
                    // Initialize: disable Continue and Submit buttons only (not Back button)
                    $carousel.find('.carousel-control-next, .guided-access-submit-btn').each(function() {
                        $(this).prop('disabled', true);
                        $(this).attr('disabled', 'disabled');
                    });
                    
                    // Check first slide
                    var $firstSlide = $carousel.find('.carousel-item.active');
                    if ($firstSlide.length) {
                        updateButtonState($firstSlide);
                    }
                });
            },


        },

        /***********************************************************
        // PAGE SPECIFIC FUNCTIONS
        ***********************************************************/
        pages = function () {

            if ($("body").hasClass('page')) {

            }

            //Set input focus on search modal
            const myModal = document.getElementById('searchModal');
            const myInput = document.getElementById('searchInput');

            myModal.addEventListener('shown.bs.modal', () => {
                myInput.focus();
            });

            //Forse filter dropdpwn to be at bootom within the viewport
            document.querySelectorAll('.filter-pill').forEach(function (button) {
            new bootstrap.Dropdown(button, {
                popperConfig: function (defaultBsPopperConfig) {
                return {
                    ...defaultBsPopperConfig,

                    placement: 'bottom-start',

                    modifiers: [
                    ...(defaultBsPopperConfig.modifiers || []),

                    // Horizontal flip only (left / right)
                    {
                        name: 'flip',
                        options: {
                        fallbackPlacements: ['bottom-start', 'bottom-end']
                        },
                    },

                    // Prevent clipping outside viewport
                    {
                        name: 'preventOverflow',
                        options: {
                        boundary: 'viewport',
                        },
                    },
                    ],
                };
                },
            });
            });

            


            
        },

        /***********************************************************
        // Other functions as required
        ***********************************************************/
        misc_func = function () { 

            // Radio Buttons de-selectable
            $(function () {
                // Store the currently checked radio button
                let lastCheckedRadio = null;

                $('input[type="radio"]').on('click', function() {
                    if (this === lastCheckedRadio) {
                    // If the same radio button is clicked again, uncheck it
                    $(this).prop('checked', false);
                    lastCheckedRadio = null; // Clear the last checked
                    } else {
                    // If a different radio button is clicked, update lastCheckedRadio
                    lastCheckedRadio = this;
                    }
                });
            });

        };


    /***********************************************************
    // Utility functions
    ***********************************************************/

    // Bootstrap breakpoint
    // @link https://unpkg.com/bootstrap-detect-breakpoint@1.0.8/src/bootstrap-detect-breakpoint.js
    bootstrapDetectBreakpoint = {

                init: function () {
                    let _self = this;

                    if ($(_self.template).length === 0) {
                        return null;
                    }

                    const bodyClasses = ($('body').attr('class') || '').split(/\s+/);
                    const isDevelopmentPage = bodyClasses.some(cls => cls.startsWith('page-development'));

                    if (isDevelopmentPage) {
                        // Special logic for development pages
                        const elements = $('main section .content-block-heading > h3');
                        elements.each(function () {
                            const section = $(this).closest('section[id]');
                            if (section.length > 0) {
                                const section_id = section.attr('id');
                                const section_heading = $(this).text();
                                if (section_id && section_heading) {
                                    _self.data.items.push({
                                        'title': section_heading,
                                        'url': '#' + section_id
                                    });
                                }
                            }
                        });
                    } else {
                        // Standard logic for all other pages
                        let sectionCounter = 0;
                        $('main section[id]').each(function () {
                            sectionCounter++;
                            const section = $(this);
                            let heading;
                            let section_heading;

                            // Priority 1: .content-block-heading > h2
                            heading = section.find('.content-block-heading > h2').first();

                            // Priority 2: heading inside .content-block-sub-kicker
                            if (heading.length === 0) {
                                heading = section.find('.content-block-sub-kicker :header').first();
                            }

                            // Priority 3: Fallback to any heading tag
                            if (heading.length === 0) {
                                const headingTags = ['h2', 'h3', 'h4', 'h5', 'h6'];
                                for (const tag of headingTags) {
                                    heading = section.find(tag).first();
                                    if (heading.length > 0) {
                                        break;
                                    }
                                }
                            }

                            if (heading.length > 0) {
                                section_heading = heading.text();
                            } else {
                                section_heading = 'Section #' + sectionCounter;
                            }
                            
                            const section_id = section.attr('id');

                            if (section_id && section_heading) {
                                _self.data.items.push({
                                    'title': section_heading,
                                    'url': '#' + section_id
                                });
                            }
                        });
                    }

                    if (_self.data.items.length > 0) {
                        _self.render_data(_self.data);
                    }
                },
        //
        detect: function () {
            // cache some values on first call
            if (!this.breakpointValues) {
                this.breakpointNames = ["xl", "lg", "md", "sm", "xs"]
                this.breakpointValues = []
                for (const breakpointName of this.breakpointNames) {
                    this.breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-' + breakpointName)
                }
            }
            let i = this.breakpointNames.length
            for (const breakpointName of this.breakpointNames) {
                i--
                if (window.matchMedia("(min-width: " + this.breakpointValues[breakpointName] + ")").matches) {
                    return { name: breakpointName, index: i }
                }
            }
            return null
        },

    },

    bootstrapTabs = {

        tabTriggerElements: {},
        tabContainerElements: {},

        init: function () {
            let _self = this;
            // // Run on initial page load after the DOM is ready
            // _self.activateTabFromHash();

            // Run on initial page load after the DOM is ready
            const hash = window.location.hash;
            if (hash) {

                // If hash have '---', this means there are two levels of tabs.
                // Split, into two parts, first part is the main tab, second part is the sub tab
                // and activate both tabs 
                if (hash.indexOf('---') > -1) {
                    const parts = hash.split('---');
                    // Split parts and loop through each hash
                    const hashes = hash.split('---');
                    // Only process first two parts
                    if (hashes.length >= 2) {
                        // First level tab
                        _self.activateTabFromHash(hashes[0].startsWith('#') ? hashes[0] : '#' + hashes[0]);
                        // Second level tab - use complete original hash
                        _self.activateTabFromHash(hash.startsWith('#') ? hash : '#' + hash);
                    }
                } else {
                    // Activate single tab
                    // _self.activateTab(hash);
                    _self.activateTabFromHash(hash);
                }



            }



            // Run when the hash changes (e.g., user clicks an internal link)
            window.addEventListener('hashchange', _self.activateTabFromHash);


            // Before a tab is shown, check if we are leaving a paginated view.
            // If so, prevent the tab from showing and reload the page to the new tab's hash without pagination.
            document.addEventListener('show.bs.tab', function(event) {
                const activatedTabTrigger = event.target;
                const targetHash = activatedTabTrigger.dataset.bsTarget || activatedTabTrigger.getAttribute('href');
                const previousTabTrigger = event.relatedTarget;

                if (previousTabTrigger && targetHash) {
                    const previousTargetHash = previousTabTrigger.dataset.bsTarget || previousTabTrigger.getAttribute('href');
                    if (previousTargetHash) {
                        const previousTabContent = document.querySelector(previousTargetHash);
                        if (previousTabContent && previousTabContent.querySelector('ul.pagination') && (window.location.pathname.includes('/page/') || new URLSearchParams(window.location.search).has('cat'))) {
                            event.preventDefault(); // Prevent the new tab from showing before reload.
                            
                            // Construct a URL object to easily manipulate search parameters
                            const currentUrl = new URL(window.location.href);
                            
                            // Remove the 'cat' parameter if it exists
                            currentUrl.searchParams.delete('cat');
                            
                            // Get the pathname and remove the pagination part
                            const cleanPath = currentUrl.pathname.replace(/\/page\/\d+\/?/, '');
                            
                            // Construct the new URL, preserving other query parameters but removing 'cat' and pagination
                            const newUrl = currentUrl.origin + cleanPath + currentUrl.search + targetHash;
                            
                            window.location.href = newUrl;
                        }
                    }
                }
            });

            // 3. Update URL hash when a tab is shown by user interaction
            //    Listen on a parent element that contains the tabs for efficiency
            const tabContainer = document.querySelector('#myTab'); // Or document.body if tabs are scattered
            if (tabContainer) {
                // tabContainer.addEventListener('shown.bs.tab', _self.updateHashOnTabShow);
            } else {
                // console.warn("Could not find tab container ('#myTab') to attach 'shown.bs.tab' listener.");
                // Fallback: listen on the whole document, less efficient but works
                // document.addEventListener('shown.bs.tab', _self.updateHashOnTabShow);
            }

        },

        activateTabFromHash: function(hash) {
            let _self = this;
            hash = hash || window.location.hash;
            if (hash) {

                // if( global.debug_mode ) {
                //     console.log("Activating tab from hash:", hash);
                // }
                
                // If the current tab's href contains pagination, update all sibling tabs to use absolute URLs without pagination.
                const currentTabLink = document.querySelector(`[data-bs-toggle="tab"][href$="${hash}"], [data-bs-toggle="pill"][href$="${hash}"]`);
                if (currentTabLink && window.location.pathname.match(/\/page\/\d+\/?/)) {
                    const cleanPath = window.location.pathname.replace(/\/page\/\d+\/?/, '/');
                    const parentNav = currentTabLink.closest('.nav');
                    if (parentNav) {
                        const siblingLinks = parentNav.querySelectorAll('[data-bs-toggle="tab"], [data-bs-toggle="pill"]');
                        siblingLinks.forEach(link => {
                            const linkHash = link.getAttribute('href');
                            if (linkHash.startsWith('#')) {
                                link.setAttribute('href', window.location.origin + cleanPath + linkHash);
                                // if( global.debug_mode ) {
                                //  console.log(linkHash);
                                // }
                            }
                        });
                    }
                }
            

                // const selector = `
                //     [data-bs-toggle="tab"][href="${hash}"],
                //     [data-bs-toggle="pill"][href="${hash}"],
                //     [data-bs-toggle="tab"][data-bs-target="${hash}"],
                //     [data-bs-toggle="pill"][data-bs-target="${hash}"]
                // `;

                // Selector now checks for href ending with the hash, to support absolute URLs.
                const selector = `
                    [data-bs-toggle="tab"][href$="${hash}"],
                    [data-bs-toggle="pill"][href$="${hash}"]
                `;

                const triggerEl = document.querySelector(selector);
    
                if (triggerEl) {

                    updateTitleFromHash(hash);

                    _self.tabTriggerElements = triggerEl;
                    _self.tabContainerElements = document.querySelector( triggerEl.getAttribute('data-bs-target') + '[role="tabpanel"]' );

                    if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
                        try {
                            const tabInstance = bootstrap.Tab.getOrCreateInstance(triggerEl);
                            if(tabInstance) {
                                // Check if it's not already active to prevent unnecessary work
                                if (!triggerEl.classList.contains('active')) {
                                    // console.log(`Activating tab ${hash} from hash change/load.`); // Debugging

                                    // Activate the tab
                                    tabInstance.show();

                                }
                            } else {
                                console.warn(`Could not get or create Bootstrap Tab instance for element:`, triggerEl);
                            }
                        } catch (error) {
                            console.error("Error activating Bootstrap tab from hash:", error);
                        }
                    } else {
                        console.warn("Bootstrap Tab component not found. Ensure Bootstrap JS is loaded.");
                    }
                }
            }
        },

        /**
         * Updates the URL hash based on the currently shown Bootstrap tab.
         * Uses history.replaceState to avoid adding entries to browser history for simple tab clicks.
         * @param {Event} event - The 'shown.bs.tab' event object.
         */
        updateHashOnTabShow: function (event, replaceState = true) {
            // event.target is the tab trigger element (<a> or <button>) that was activated
            const activatedTabTrigger = event.target;
            let targetHash = activatedTabTrigger.dataset.bsTarget || activatedTabTrigger.getAttribute('href');

            // Ensure targetHash is a valid hash string (starts with #)
            if (targetHash && targetHash.startsWith('#')) {
                // if( global.debug_mode ) {
                //     console.log(`Tab shown: ${targetHash}. Updating URL.`); // Debugging
                // }
                // Use replaceState so clicking tabs doesn't clutter browser history
                // Use pushState if you *want* the back button to cycle through tab clicks
                if (window.history) {
                    // Check if the current hash is already the target hash to avoid unnecessary replaceState calls
                    if(window.location.hash !== targetHash) {
                        if(replaceState){    
                            history.replaceState(null, '', targetHash);
                        } else {
                            history.pushState(null, '', targetHash);
                        }
                    }

                    // If 'activatedTabTrigger' have parent id like "#grouped-content", update title to "Grouped Content"                    
                    if( activatedTabTrigger.closest('#grouped-content') !== null ) {
                        // Update document title
                        updateTitleFromHash(targetHash);
                    }
                    
                } else {
                    // Fallback for older browsers (might trigger hashchange)
                    window.location.hash = targetHash;
                }
            } else {
                // If the activated tab doesn't have a valid hash target (like the default 'Home' tab might if not set up)
                // Optionally clear the hash or set it to a default like '#'
                // console.log(`Tab shown: No valid hash target found. Clearing URL hash.`); // Debugging
                if (window.history) {
                    // Clear the hash by replacing the state with the current path without a hash
                    if(window.location.hash) { // Only clear if there is a hash
                        if(replaceState){    
                            history.replaceState(null, '', window.location.pathname + window.location.search);
                        } else {
                            history.pushState(null, '', window.location.pathname + window.location.search);
                        }
                    }
                } else {
                    // Fallback
                    if(window.location.hash) {
                        window.location.hash = '#'; // Or just '' depending on desired behavior
                    }
                }
            }
        }
    },

    // Utility method to get browser data
    get_storage = function (storageName, is_persistentStorage = true, expires = '') {

        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {

                // Not expiry
                var expires = '';

                // LocalStorage
                storageData = window.localStorage.getItem(storageName);

                if (expires != '') {
                    storageDataExpiry = window.sessionStorage.getItem('_' + storageName);
                }
                else {
                    storageDataExpiry = false;
                }


            } else {

                // 1 hour by default
                var expires = '';

                // SessionStorage
                storageData = window.sessionStorage.getItem(storageName);

                if (expires != '') {
                    storageDataExpiry = window.sessionStorage.getItem('_' + storageName);
                } else {
                    storageDataExpiry = false;
                }

            }

            // Check if expired
            if (storageDataExpiry !== false && (storageDataExpiry != '' || storageDataExpiry == 'undefined' || Date.now() > storageDataExpiry)) {
                delete_storage(storageName, is_persistentStorage);
            }

            if (storageData != null || storageData != "undefined") {

                // Always try to return as data as JS object if JSON or other data types
                try {
                    return JSON.parse(storageData);
                } catch (e) {
                    return storageData;
                }
            } else {
                return false;
            }

        }
        else {
            return false;
        }

    };

    // Utility method to store browser data and defaults to an hour
    set_storage = function (storageName, storageData, is_persistentStorage = true, expires = '') {


        if (storageName != "") {

            // Always assume data is for JSON and escape data were necessary
            var storageData = JSON.stringify(storageData);

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {

                // Not expiry
                var expires = '';

                // LocalStorage
                window.localStorage.setItem(storageName, storageData);

                if (expires != '') {
                    window.localStorage.setItem('_' + storageName, Date.now() + expires);
                }

            } else {

                // Default 1 hour by default
                // var expires = (60*60*1000);

                // SessionStorage
                window.sessionStorage.setItem(storageName, storageData);
                if (expires != '') {
                    window.sessionStorage.setItem('_' + storageName, Date.now() + expires);
                }
            }
            return true;
        }
        else {
            return false;
        }

    };

    // Utility method to store browser data
    delete_storage = function (storageName, is_persistentStorage = true) {


        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                window.localStorage.removeItem(storageName);
                window.localStorage.removeItem(storageName + '_expires');

            } else {
                // SessionStorage
                window.sessionStorage.removeItem(storageName);
                window.sessionStorage.removeItem(storageName + '_expires');
            }



        }
        else {
            return false;
        }
    };


    // Update HTML Document Title based on hash
    updateTitleFromHash = function(hash) {
        if (hash && hash.startsWith('#')) {
            // If hash contains '---', use the part before it for the title
            if (hash.includes('---')) {
                hash = hash.split('---')[0];
            }
            
            if (hash.toLowerCase() === '#all') {
                document.title = global.original_document_title;
            } else {


                
                // Only update title if hash (without '#') does NOT start with 'pg-group'
                const hashWithoutHash = hash.substring(1);
                if (!hashWithoutHash.toLowerCase().startsWith('pg-group')) {
                    // Capitalize each word and replace dashes with spaces
                    let titlePart = hashWithoutHash.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    updateDocumentTitle(titlePart);
                }
            }
        }
    };


    // Update HTML Document Title
    updateDocumentTitle = function (pageTitle) {
        const documentTitleSeparatorWithSpaces = " | ";
        document.title = pageTitle + documentTitleSeparatorWithSpaces + global.original_document_title;
        return document.title;
    };


    // Initialise JS Class and functions
    return {

        init: function () {

            // DEBUG RELATED
            if (global.debug_mode) {

                console.log("Debug Mode: " + global.debug_mode);

            }

           

            // Detect breakpoint/viewport
            bootstrapDetectBreakpoint.init();

            // Bootstrap tabs
            bootstrapTabs.init();

            // Enable Bootstrap tooltips
            (function() {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.forEach(function (tooltipTriggerEl) {
                    new bootstrap.Tooltip(tooltipTriggerEl);
                });
            })();
            
            // Components Used throughout the site
            components.swiperjs();
            components.siteNav();
            components.taxonomiesListingFilters(); // Resources listing filters
            components.postsEventsFilters(); // Posts & Events listing filters
            components.copyLink(); // Copy link to clipboard functionality
            components.webShare(); // Web Share API functionality
            components.pageSectionsMenu.init(); // In-line page menu
            components.expandCollapse(); // Expand/collapse functionality for listings
            components.guidedAccessCarousel(); // Guided access carousel functionality
            //components.gsapAnimations();
            
            //AOS Libarry
            //https://michalsnik.github.io/aos/
            AOS.init({
                // anchorPlacement: 'top-bottom',
                offset: 200,
            });

            // Page Specific functions
            pages();

            // Sync external notification carousel indicators with Bootstrap slide events
            document.querySelectorAll('.notifications-carousel').forEach(function (carousel) {
                var indicators = carousel.parentElement
                    ? carousel.parentElement.querySelectorAll('.notifications-carousel-indicators button')
                    : [];
                if (!indicators.length) return;

                carousel.addEventListener('slide.bs.carousel', function (e) {
                    indicators.forEach(function (btn) {
                        btn.classList.remove('active');
                        btn.removeAttribute('aria-current');
                    });
                    if (indicators[e.to]) {
                        indicators[e.to].classList.add('active');
                        indicators[e.to].setAttribute('aria-current', 'true');
                    }
                });
            });

            // Misc functions
            misc_func();

            

        },
    };

}());

jQuery(function () {
    SparkDigital.init();
});
